export const environment = {
    platformApiBaseUrl: process.env.REACT_APP_API_BASE_URL,
    partnerPortalHeapId: process.env.REACT_APP_HEAP_ENV_ID,
    sentryDsn: process.env.REACT_APP_SENTRY_DSN,
    pusher: {
        token: process.env.REACT_APP_X_PUSHER_TOKEN,
        key: process.env.REACT_APP_PUSHER_APP_KEY,
    },
    auth0: {
        domain: process.env.REACT_APP_AUTH0_DOMAIN,
        clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
        apiId: process.env.REACT_APP_AUTH0_API_ID,
        claimNamespace: process.env.REACT_APP_AUTH0_TOKEN_CLAIM_NAMESPACE,
        logoutRedirect: process.env.REACT_APP_BASE_URL,
        timeout: process.env.REACT_APP_AUTH0_TIMEOUT,
    },
}
